import { MutableRefObject, useEffect, useRef } from 'react';

const useAutoFocus = <T extends HTMLButtonElement>(
  trigger: boolean,
  dependencyList: React.DependencyList = []
): MutableRefObject<T | null> => {
  const buttonRef = useRef<T | null>(null);

  useEffect(() => {
    if (trigger && buttonRef?.current) {
      buttonRef.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, ...dependencyList]);

  return buttonRef;
};

export default useAutoFocus;
